import type { FilterOperationSchema } from '../../types.js';

type Keys = 'inArray' | 'beginsWith' | 'endsWith' | 'containsLoose' | 'containsStrict' | 'doesNotContain';

export const STRING_ARRAY_FILTER_OPERATION: FilterOperationSchema<Keys> = {
    inArray: {
        id: 'inArray',
        label: 'Filterliste',
    },
    // ---
    beginsWith: {
        id: 'beginsWith',
        label: 'Beginnt mit',
    },
    endsWith: {
        id: 'endsWith',
        label: 'Endet mit',
    },
    // ---
    containsLoose: {
        id: 'containsLoose',
        label: 'Enthält (locker)',
    },
    containsStrict: {
        id: 'containsStrict',
        label: 'Enthält (genau)',
    },
    doesNotContain: {
        id: 'doesNotContain',
        label: 'Enthält nicht',
    },
} as const;

export type StringArrayFilter = typeof STRING_ARRAY_FILTER_OPERATION;
export type StringArrayFilterValues = StringArrayFilter[keyof typeof STRING_ARRAY_FILTER_OPERATION];
export type StringArrayFilterValuesWithoutInArray = Exclude<StringArrayFilterValues, StringArrayFilter['inArray']>;
